'use client';
import cn from 'classnames';
import Image, { StaticImageData } from 'next/image';

import './AspectRatioImage.style.scss';

type AspectRatioImageProps = {
  className?: string;
  height: number;
  width: number;
  src: string | StaticImageData;
  alt: string;
  priority?: boolean;
};

/**
 * A component that maintains an image's aspect ratio using the
 * "padding-bottom" percentage trick.
 * This magical image trick has the potential to
 * cause Layout Content Shift (LCS) issues. Please refrain
 * from using this component above the fold
 */
function AspectRatioImage(props: AspectRatioImageProps) {
  const { className = '', height, width, src, alt, priority = false } = props;

  return (
    <div className={cn('AspectRatioImage', className)}>
      <div
        className='AspectRatioImage-ratio-container'
        style={{ paddingBottom: `${(height / width) * 100}%` }}
      >
        <Image
          className='AspectRatioImage-image'
          height={height}
          width={width}
          src={src}
          alt={alt}
          priority={priority}
        />
      </div>
    </div>
  );
}

export default AspectRatioImage;
